<template>
  <div id="id" class="gamebox">
    <Navigation :browse="browse"/>
    <!-- Main Wrapper-->
    <main>
      <div class="wrap">
        
       <router-view :main="main" :browse="browse"></router-view>
      </div>
      <DetailModal/>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import gamebox from "./router/gamebox";
import gameboxData from "./components/gamebox/gamebox.js";
import country_list from "./locales/country_list.json";
import Navigation from "./components/gamebox/Navigation.vue";
import DetailModal from "./components/gamebox/DetailModal";
import { mapGetters, mapActions } from "vuex";
import AxiosPlugin from "vue-axios-cors";

Vue.use(VueRouter);
Vue.use(AxiosPlugin);

export default {
  name: "gamebox",
  data() {
    return {
      browse: gameboxData.browse,
      main: gameboxData.main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in")
    };
  },
  components: {
    Navigation,
    DetailModal
  },
  computed: mapGetters(["lang_gamebox", "country_gamebox"]),
  mounted() {},
  created() {
    this.fetchToken_gamebox(this.id);

    if (window.location.pathname === "/") {
      gamebox.push({ name: "Main" }).catch(err => {});
    }

    let lang = this.lang_gamebox;
    let country_code = this.country_gamebox;

    if (this.lang_gamebox != "null" && this.lang_gamebox != null) {
      if (this.lang_gamebox == "arabic") {
        localStorage.setItem("lang_gamebox", this.lang_gamebox);
        this.$i18n.locale = this.lang_gamebox;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_gamebox(this.lang_gamebox);
      } else {
        localStorage.setItem("lang_gamebox", this.lang_gamebox);
        this.$i18n.locale = this.lang_gamebox;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_gamebox(this.lang_gamebox);
      }
    } else {
      let country_ls = Object.keys(country_list);

      if (country_ls.includes(country_code)) {
        let language = country_list[country_code].language;

        localStorage.setItem("lang_gamebox", language);
        this.$i18n.locale = language;
        this.fetchLocale_gamebox(language);

        if (language != "arabic") {
          document
            .getElementsByTagName("html")[0]
            .classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_gamebox", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_gamebox("english");
      }
    }
  },

  methods: {
    ...mapActions(["fetchLocale_gamebox", "fetchToken_gamebox"]),

    enter(el, done) {},
    leave(el, done) {}
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/");
      const fromDepth = from.path.split("/");
      //set content panel height of detail  page

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import url("./assets/gamebox/styles/app.scss");
.privacy_color, .mobiSection__content, .mobitxt{
  color:white;
}
/* .fade-enter-active,
.fade-leave-active {
   transition-property: opacity;
   transition-duration: 0.25s; }

 .fade-enter-active {
   transition-delay: 0.25s;
 }

 .fade-enter,
 .fade-leave-active {
   opacity: 0;
} */

/*##### Arabic layout Styles#####*/

/*##### Responsive layout Styles#####*/
</style>



// WEBPACK FOOTER //
// src/GameBox.vue